<template>
  <li @click="$emit('handleSelect', label)">
    <div class="row">
      <div class="col-xs-1 text-center text-muted strong">{{ label.id }}</div>
      <div class="col-xs-5">{{ labelType }}</div>
      <div class="col-xs-2">{{ label.created_at | date({ format: "DD/MM/YYYY h:mma", utc: false }) }}</div>
      <div class="col-xs-2"></div>
    </div>
  </li>
</template>

<script>
export default {
  props: {
    label: Object
  },

  computed: {
    labelType () {
      switch (this.label.type) {
        case 1:
          return 'Barcode'
        case 2:
          return 'Asset Label'
        case 3:
          return 'Hanger Label'
        case 4:
          return 'Station Label'
        case 5:
          return 'Product Label'
        case 6:
          return 'Order Fulfilment Label'
        case 7:
          return 'Auspost Label'
      }
      return ''
    }
  }
}
</script>
